var map = {
	"./da": 28580,
	"./da.js": 28580,
	"./en-gb": 78208,
	"./en-gb.js": 78208,
	"./en-ie": 37256,
	"./en-ie.js": 37256,
	"./fr": 19237,
	"./fr-ca": 4538,
	"./fr-ca.js": 4538,
	"./fr.js": 19237,
	"./ja": 65890,
	"./ja.js": 65890,
	"./ms": 16954,
	"./ms.js": 16954,
	"./uk": 94353,
	"./uk.js": 94353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89705;